export const servObj = (window.servObj = {});

servObj.onHover3D = [];
servObj.onClick3D = [];
servObj.onSoundChange = [];
servObj.currentCount = {
    count: 1,
    setCount: function (newCount) {
        if (newCount > 0) {
            this.count = newCount;
        }
    },
};
servObj.annotationVisibilityDistance = 30; // Порог расстояния от камеры до аннотации для её отображения
servObj.activeViewMode = {
    is3d: true,
    is2d: false,
    isFPV: false,

    setViewMode: function (mode) {
        this.is3d = mode === '3d';
        this.is2d = mode === '2d';
        this.isFPV = mode === 'fpv';
    },
};

let sound = false;
Object.defineProperty(servObj, 'sound', {
    set: function (newValue) {
        sound = newValue;
        servObj.onSoundChange.forEach((callback) => callback(sound));
    },
    get: function () {
        return sound;
    },
});
